import type { EstadoSync } from './estadoSync'

export type CorDaBarra = 'verde' | 'ambar' | 'vermelho'

export interface RotuloBarra {
  cor: CorDaBarra
  texto: string
}

// O texto tem BASE + COMPLEMENTO, e isso nao e enfeite:
//
// - a BASE e o que manda -- travado ganha de todo estado, porque ate 2026-08-07
//   a barra dizia "Sincronizado" em verde com a fila cheia de recusado;
// - o COMPLEMENTO e a fila que ainda vai tentar, e aparece SEMPRE que existe.
//   Dobrar a contagem dentro do estado escondia dela: quem estava sem sinal via
//   so "Offline", e quem estava sincronizando via so "Sincronizando…", sem
//   saber quanta coisa faltava subir. A barra antiga mostrava as duas coisas em
//   lugares separados, e essa informacao nao pode se perder.
export function rotuloDaBarra(
  estado: EstadoSync,
  pendencias: number,
  travados: number,
): RotuloBarra {
  let cor: CorDaBarra = 'verde'
  let base = 'Sincronizado'

  if (travados > 0) {
    cor = 'vermelho'
    base = travados === 1 ? '1 não subiu' : `${travados} não subiram`
  } else if (estado === 'erro') {
    cor = 'vermelho'
    base = 'Erro ao sincronizar'
  } else if (estado === 'sincronizando') {
    base = 'Sincronizando…'
  } else if (estado === 'offline') {
    cor = 'ambar'
    base = 'Offline'
  } else if (pendencias > 0) {
    // Ocioso com fila: o numero e a noticia, "Sincronizado" seria mentira.
    cor = 'ambar'
    base = ''
  }

  const complemento = pendencias > 0 ? `${pendencias} esperando` : ''
  const texto = [base, complemento].filter(Boolean).join(' · ')
  return { cor, texto }
}
